import { useContext } from "react";

import { useTranslation } from "react-i18next";
import styled from "styled-components";

import type { Ailment } from "api/schemas/shared/Treatment";
import { CurrentPatientContext } from "utils/contexts";
import { translateTreatment } from "utils/translations";

interface Props {
  ailment?: Ailment;
}

export const PatientDetails: React.FC<Props> = ({ ailment }) => {
  const { patient } = useContext(CurrentPatientContext);
  const { t } = useTranslation();
  const patientName = `${patient.first_name} ${patient.last_name}`;

  const { location, lateral_location } = patient?.most_painful_location ?? {};

  const currentProtocolWeek = patient.week;

  return (
    <Root>
      <div>
        <Label>{t("usercourse.patient")}</Label>
        <Detail>{patientName}</Detail>
      </div>
      <div>
        <Label>{t("patients.ailment")}</Label>
        <Detail>{translateTreatment({ ailment, lateral_location, location })}</Detail>
      </div>
      <div>
        <Label>{t("usercourse.protocol_week")}</Label>
        <Detail>{currentProtocolWeek}</Detail>
      </div>
    </Root>
  );
};

const Detail = styled.div`
  font-size: 14px;
`;
const Label = styled.div`
  color: ${props => props.theme.colors.redesign.db60};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 6px;
`;

const Root = styled.div`
  display: flex;
  gap: 22px;
  padding: 24px 32px;
  background-color: #f8f8f8;
  flex-wrap: wrap;
`;
